import { createAction } from 'redux-actions';
import msgManage from '../utils/msgManage'

export const add_msg = createAction('ADD_MSG', msgManage.add_msg)


// WEBPACK FOOTER //
// ./src/dashboards_redux/actions/msgAction.jsx